export type EuroCents = [number,number];

function $$( value:number)
{
  if ( value < 10 )
  {
    return "0" + value;
  }

  return value;
}

export class ConsumerPrice
{
  net:EuroCents;
  gross:EuroCents;
  tax:EuroCents;
  taxRate:number;

  static ensureCompletness( price:ConsumerPrice )
  {
    return this.fromGross( price.gross );
  }

  static asLabel( price:EuroCents, currency:string = "€" )
  {
    return `${price[0]},${$$(price[1])} ${currency}`
  }

  static toPayPalPrice( price:ConsumerPrice )
  {
    return `${price.gross[0]}.${$$(price.gross[1])}`;
  }

  static toMultiString( price:EuroCents )
  {
    let euro = price[ 0 ];
    let cents = $$( price[ 1 ] );

    return { en: `${euro},${cents}`, de: `${euro},${cents}` };
  }

  static fromGross( price:EuroCents, taxRate:number = 0.19 )
  {
    let cents = price[ 0 ] * 100 + price[ 1 ];
    let netPrice = cents / ( 1 + taxRate );
    let tax = Math.round( cents - netPrice );

    let roundedNetPrice = cents - tax;

    let cp = new ConsumerPrice();
    cp.net = ConsumerPrice.fromCentsToEuroCents( roundedNetPrice );
    cp.tax = ConsumerPrice.fromCentsToEuroCents( tax );
    cp.gross = [].concat( price ) as EuroCents;
    cp.taxRate = taxRate;

    return cp;

  }

  static fromCentsToEuroCents( cents:number ):EuroCents
  {
    let centsOnly = cents % 100;
    let euros = Math.floor( ( cents - centsOnly ) / 100 );

    return [ euros, centsOnly ];
  }

  static sum( prices:ConsumerPrice[] ):ConsumerPrice
  {
     let cents = 0;

     prices.forEach(
      ( p )=>
      {
        cents += p.gross[ 0 ] * 100 + p.gross[ 1 ];
      }
     );

     let gross = this.fromCentsToEuroCents( cents );

     return ConsumerPrice.fromGross( gross );
     
  }

  static multiply( price:ConsumerPrice, amount:number ):ConsumerPrice
  {
    let gross = price.gross;
    let cents = gross[ 0 ] * 100 + gross[ 1 ];
    let multipliedCents = cents * amount;
    let multipliedGross = this.fromCentsToEuroCents( multipliedCents );
    return ConsumerPrice.fromGross( multipliedGross );
  }

}